<div class="add-cust-dialog">
  <header class="add-cust-dialog__header">
    <div class="add-cust-dialog__title">
      <mat-icon>person_add</mat-icon>
      <span>Add Customer</span>
    </div>
    <button class="add-cust-dialog__close" type="button" (click)="cancel()" aria-label="Close" matTooltip="Close">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <p class="add-cust-dialog__hint">
    Enter the customer's phone number or email. We'll attach them to this order
    <ng-container *ngIf="rewardsEnabled">and check rewards.</ng-container>
  </p>

  <div class="add-cust-dialog__field">
    <mat-icon class="add-cust-dialog__field-icon">
      {{ isEmail ? 'mail' : (isPhone ? 'phone' : 'person_search') }}
    </mat-icon>
    <input class="add-cust-dialog__input"
           type="text"
           [(ngModel)]="input"
           placeholder="Phone or email"
           (keydown.enter)="submit()"
           autofocus />
    <span class="add-cust-dialog__badge" *ngIf="rewardsEnabled && isPhone">
      Rewards
    </span>
  </div>

  <footer class="add-cust-dialog__footer">
    <button class="add-cust-dialog__btn add-cust-dialog__btn--ghost" type="button" (click)="cancel()">
      Cancel
    </button>
    <button class="add-cust-dialog__btn add-cust-dialog__btn--primary"
            type="button"
            [disabled]="!canSubmit"
            (click)="submit()">
      Add Customer
    </button>
  </footer>
</div>
